<template>
  <SideModal
    :show="show"
    @update:show="$emit('update:show', $event)"
    location="right"
    close-on-overlay-click
    data-cy="instructions-modal"
  >
    <div class="con" data-cy="instructions-modal-content">
      <div class="d-flex align-center justify-space-between">
        <div class="title">{{ integration.title }} Integration Instructions</div>
        <v-btn color="transparent" icon @click="$emit('update:show', false)" data-cy="instructions-modal-close"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <div v-if="integration.value === 'blackbaud'">
        <div class="mt-5" style="color: gray">
          If you are using Blackbaud integration then a Blackbaud sync tool will appear in the
          integration page.
          <br />
          Save integration settings then connect to your Blackbaud account
          <br />
          After Blackbaud integration is ready to use, you'll be able sync from Blackbaud
          <br />
          <br />
          <a
            style="text-decoration: none; color: gray"
            href="https://ptcwizard.freshdesk.com/a/solutions/articles/3000109405"
            target="_blank"
          >
            <b>Click here for Instructions to connect SKY API</b>
          </a>
        </div>
      </div>
      <div v-else-if="integration.value === 'nycdoe'">
        <div class="mt-10" style="color: gray;">
        <h6>PTC Wizard is an approved vendor with the NYC</h6>
        <p/>
        In order to leverage the NYC DOE integration with the DOE Stars system, you must first submit an ERMA request to the DOE.
        <p>&nbsp;</p>
        <a href="https://infohub.nyced.org/nyc-doe-topics/it/doe-applications-and-systems/enterprise-request-management-application-erma">
          Click here to log to submit the ERMA request
        </a>
        <p>&nbsp;</p>
        <a href="https://www.ptcwizard.com/media/PTC_Wizard_ERMA_Request_Guide.pdf" target="_blank">
          Click here for Instructions to submit the ERMA request
        </a>
        <p>&nbsp;</p>
        <div>
        Your school code is the same as your DBN.
        <p>&nbsp;</p>
        Once your ERMA request is approved, PTC Wizard will be able to sync your data from Stars System.
        <br/> 
        <b>Please save the ERMA request number and share it with support@ptcwizard so that we can try to help follow up with the DOE.</b>
        <br/>You might need to submit a support ticket to the DOE with your ERMA request number and DBN to find out the status.
        <p>&nbsp;</p>
        Parents are able to register themselves into your PTC Wizard account and add students using their OSIS number.
        <p>&nbsp;</p>
        Once a parent registers and adds an OSIS number to their account, all of the teachers connected to the student will become connected to the parent.
        <br/>
        This will filter the list of teachers for the parents when they try to make appointments.
        <p>&nbsp;</p>
        (If you are interested in showing more teachers, you can enable the show more teachers  button)
        </div>
        </div>
      </div>
      <div v-else-if="integration.value === 'synergy'">
        <div class="mt-5" style="color: gray">
          Synergy can sync roster data using OneRoster or CSV files.
          <br />
          <br />
          Use the OneRoster tab to connect your Synergy OneRoster API, or the CSV tab to upload
          files.
          <br />
          <br />
          To enable ParentVUE SSO, click SSO and turn on Enable ParentVUE SSO. The ParentVUE URL is
          in that panel.
        </div>
      </div>
      <div v-else-if="integration.value === 'facts'">
        <div class="mt-10" style="color: gray;">
        <h6>PTC Wizard can integrate with the Facts API</h6>
        <p/>
        In order to leverage the Facts API integration, you must first get an API Key from the Facts API using our subscription id.
        <p>&nbsp;</p>
        The PTC Wizard subscription id is: 08e35083c8254d22bd3a1a7687d2d4c9
        Log into the Facts API and click on the "API Configuration" tab.
        <p>&nbsp;</p>
        Click the Add Key button  to open the Create Api Key dialog.
        <p>&nbsp;</p>
        Enter our subscription Id and name the key "PTCWizard"
        Set the Scopes to read for <ul>
          <li>Academics</li>
          <li>Gradebook</li>
          <li>People</li>
        </ul>
        
        <p>&nbsp;</p>
        Click the Generate button.
      <p></p>
      Copy the API Key and paste it into the API Key field in the PTC Wizard integration page.
      <br/>
      Click the Save button to save the integration.
      <br/>
      Now you can sync data from Facts API to PTC Wizard.
        </div>
      </div>
      <div v-else>
        <div class="mt-5" style="color: gray">
          Integrated version means that the school uploads files beforehand so the parents already
          have their login information and they are already connected to the teachers they need to
          see.

          <br />
          <br />

          The file format we use to integrate external data into our database is CSV. A CSV is a
          comma separated values file which allows data to be saved in a table structured format.
          CSVs look like a garden-variety spreadsheet but with a .csv extension. Traditionally they
          take the form of a text file containing information separated by commas, hence the name.

          <br />
          <br />

          CSV files can be used with any spreadsheet program, such as Microsoft Excel, Numbers, Open
          Office Calc, or Google Spreadsheets. They differ from other spreadsheet file types in that
          you can only have a single sheet in a file, they can not save cell, column, or row
          styling, and can not save formulas.

          <br />
          <br />

          Every CSV file with different data, like the list of parents, students, teachers, parent
          relationship and enrollment list (links between teachers and students) is uploaded one
          after another to create a database.
          <br />
          <br />
          <a
            style="text-decoration: none; color: gray"
            href="https://ptcwizard.freshdesk.com/support/solutions/articles/3000048509-creating-and-uploading-csv-files-"
            target="_blank"
          >
            <b>Click here for Instructions to upload CSV files</b>
          </a>
        </div>
      </div>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import SideModal from "@/components/sideModal.vue";
import type { integrationTypes } from "./utils";

defineProps<{
  show: boolean;
  integration: (typeof integrationTypes)[number];
}>();

defineEmits<{
  (event: "update:show", val: boolean): void;
}>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.con {
  padding: 20px 40px;
}

.title {
  color: $primary;
  font-size: 1.25rem;
  font-weight: 600;
}
</style>
